export const formatDate = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
}

export function convertTimeFormat(timeNum) {
    if (timeNum === null || timeNum === undefined || timeNum === '') return ''

    const raw = String(timeNum).trim()
    if (!raw) return ''

    // 已经是 HH:mm:ss / H:m:s 这类格式时，做标准化补零
    if (raw.includes(':')) {
        const parts = raw.split(':').map((x) => x.trim())
        if (parts.length === 3) {
            const hh = String(parseInt(parts[0] || '0', 10) || 0).padStart(2, '0')
            const mm = String(parseInt(parts[1] || '0', 10) || 0).padStart(2, '0')
            const ss = String(parseInt(parts[2] || '0', 10) || 0).padStart(2, '0')
            return `${hh}:${mm}:${ss}`
        }
    }

    // 纯数字格式（如 92505 / 092505）
    let timeStr = raw.replace(/\D/g, '')
    while (timeStr.length < 6) {
        timeStr = '0' + timeStr
    }
    const hours = String(parseInt(timeStr.substring(0, 2), 10) || 0).padStart(2, '0')
    const minutes = timeStr.substring(2, 4).padStart(2, '0')
    const seconds = timeStr.substring(4, 6).padStart(2, '0')
    return `${hours}:${minutes}:${seconds}`
}